module.exports = __webpack_public_path__ + "img/inquiry.7df40079.svg";